'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
/**
 * [browseType 设备类型]
 *
 * @return  {[type]}  [return description]
 */
var deviceType = exports.deviceType = function deviceType() {
	var u = navigator.userAgent;
	var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
	var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
	if (isAndroid) {
		return 'android';
	} else if (isiOS) {
		return 'ios';
	} else {
		return 'pc';
	}
};
/**
 * 判断是否是微信,qq 或 支付宝
 */
var wxQqZfb = exports.wxQqZfb = function wxQqZfb() {
	var u = navigator.userAgent;
	var obj = {
		wx: u.indexOf("MicroMessenger") > -1, //是否微信
		qq: u.match(/QQ/i) == "qq" && !u.indexOf('MQQBrowser') > -1, //是否QQ
		zfb: u.indexOf('alipayclient') > -1 //是否支付宝
	};
	return Object.keys(obj)[Object.values(obj).indexOf(true)];
};
/**
 * [browseType 浏览器类型]
 *
 * @return  {[type]}  [return description]
 */
var browseType = exports.browseType = function browseType() {
	// 权重：系统 + 系统版本 > 平台 > 内核 + 载体 + 内核版本 + 载体版本 > 外壳 + 外壳版本
	var ua = navigator.userAgent.toLowerCase();
	var testUa = function testUa(regexp) {
		return regexp.test(ua);
	};
	var testVs = function testVs(regexp) {
		return ua.match(regexp).toString().replace(/[^0-9|_.]/g, "").replace(/_/g, ".");
	};
	// 系统
	var system = "unknow";
	if (testUa(/windows|win32|win64|wow32|wow64/g)) {
		system = "windows"; // windows系统
	} else if (testUa(/macintosh|macintel/g)) {
		system = "macos"; // macos系统
	} else if (testUa(/x11/g)) {
		system = "linux"; // linux系统
	} else if (testUa(/android|adr/g)) {
		system = "android"; // android系统
	} else if (testUa(/ios|iphone|ipad|ipod|iwatch/g)) {
		system = "ios"; // ios系统
	}
	// 系统版本
	var systemVs = "unknow";
	if (system === "windows") {
		if (testUa(/windows nt 5.0|windows 2000/g)) {
			systemVs = "2000";
		} else if (testUa(/windows nt 5.1|windows xp/g)) {
			systemVs = "xp";
		} else if (testUa(/windows nt 5.2|windows 2003/g)) {
			systemVs = "2003";
		} else if (testUa(/windows nt 6.0|windows vista/g)) {
			systemVs = "vista";
		} else if (testUa(/windows nt 6.1|windows 7/g)) {
			systemVs = "7";
		} else if (testUa(/windows nt 6.2|windows 8/g)) {
			systemVs = "8";
		} else if (testUa(/windows nt 6.3|windows 8.1/g)) {
			systemVs = "8.1";
		} else if (testUa(/windows nt 10.0|windows 10/g)) {
			systemVs = "10";
		}
	} else if (system === "macos") {
		systemVs = testVs(/os x [\d._]+/g);
	} else if (system === "android") {
		systemVs = testVs(/android [\d._]+/g);
	} else if (system === "ios") {
		systemVs = testVs(/os [\d._]+/g);
	}
	// 平台
	var platform = "unknow";
	if (system === "windows" || system === "macos" || system === "linux") {
		platform = "desktop"; // 桌面端
	} else if (system === "android" || system === "ios" || testUa(/mobile/g)) {
		platform = "mobile"; // 移动端
	}
	// 内核和载体
	var engine = "unknow";
	var supporter = "unknow";
	if (testUa(/applewebkit/g)) {
		engine = "webkit"; // webkit内核
		if (testUa(/edge/g)) {
			supporter = "edge"; // edge浏览器
		} else if (testUa(/opr/g)) {
			supporter = "opera"; // opera浏览器
		} else if (testUa(/chrome/g)) {
			supporter = "chrome"; // chrome浏览器
		} else if (testUa(/safari/g)) {
			supporter = "safari"; // safari浏览器
		}
	} else if (testUa(/gecko/g) && testUa(/firefox/g)) {
		engine = "gecko"; // gecko内核
		supporter = "firefox"; // firefox浏览器
	} else if (testUa(/presto/g)) {
		engine = "presto"; // presto内核
		supporter = "opera"; // opera浏览器
	} else if (testUa(/trident|compatible|msie/g)) {
		engine = "trident"; // trident内核
		supporter = "iexplore"; // iexplore浏览器
	}
	// 内核版本
	var engineVs = "unknow";
	if (engine === "webkit") {
		engineVs = testVs(/applewebkit\/[\d._]+/g);
	} else if (engine === "gecko") {
		engineVs = testVs(/gecko\/[\d._]+/g);
	} else if (engine === "presto") {
		engineVs = testVs(/presto\/[\d._]+/g);
	} else if (engine === "trident") {
		engineVs = testVs(/trident\/[\d._]+/g);
	}
	// 载体版本
	var supporterVs = "unknow";
	if (supporter === "chrome") {
		supporterVs = testVs(/chrome\/[\d._]+/g);
	} else if (supporter === "safari") {
		supporterVs = testVs(/version\/[\d._]+/g);
	} else if (supporter === "firefox") {
		supporterVs = testVs(/firefox\/[\d._]+/g);
	} else if (supporter === "opera") {
		supporterVs = testVs(/opr\/[\d._]+/g);
	} else if (supporter === "iexplore") {
		supporterVs = testVs(/(msie [\d._]+)|(rv:[\d._]+)/g);
	} else if (supporter === "edge") {
		supporterVs = testVs(/edge\/[\d._]+/g);
	}
	// 外壳和外壳版本
	var shell = "none";
	var shellVs = "unknow";
	if (testUa(/micromessenger/g)) {
		shell = "wechat"; // 微信浏览器
		shellVs = testVs(/micromessenger\/[\d._]+/g);
	} else if (testUa(/qqbrowser/g)) {
		shell = "qq"; // QQ浏览器
		shellVs = testVs(/qqbrowser\/[\d._]+/g);
	} else if (testUa(/ucbrowser/g)) {
		shell = "uc"; // UC浏览器
		shellVs = testVs(/ucbrowser\/[\d._]+/g);
	} else if (testUa(/qihu 360se/g)) {
		shell = "360"; // 360浏览器(无版本)
	} else if (testUa(/2345explorer/g)) {
		shell = "2345"; // 2345浏览器
		shellVs = testVs(/2345explorer\/[\d._]+/g);
	} else if (testUa(/metasr/g)) {
		shell = "sougou"; // 搜狗浏览器(无版本)
	} else if (testUa(/lbbrowser/g)) {
		shell = "liebao"; // 猎豹浏览器(无版本)
	} else if (testUa(/maxthon/g)) {
		shell = "maxthon"; // 遨游浏览器
		shellVs = testVs(/maxthon\/[\d._]+/g);
	} else {
		shell = "";
		shellVs = "";
	}
	return {
		engine: engine, // webkit gecko presto trident
		engineVs: engineVs,
		platform: platform, // desktop mobile
		supporter: supporter, // chrome safari firefox opera iexplore edge
		supporterVs: supporterVs,
		system: system, // windows macos linux android ios
		systemVs: systemVs,
		shell: shell, // wechat qq uc 360 2345 sougou liebao maxthon
		shellVs: shellVs
	};
};
exports.default = {
	deviceType: deviceType,
	browseType: browseType,
	wxQqZfb: wxQqZfb
};